/**
 * Drawer nav labels (top-level and Champions sub-items when i18n is on).
 * @param {import('i18next').TFunction} t
 * @param {{ name?: string } | null | undefined} organization
 */
/** Pre-i18n drawer labels (master). */
export function getLegacyDrawerTopLevelLabels(organization) {
  return {
    organization: organization?.name || 'Organization',
    people: 'People',
    champions: 'Champions',
    messages: 'Messages',
    donations: 'Donations',
    tripPlanner: 'Trip Planner',
    groups: 'Groups',
    events: 'Events',
    kiosk: 'Kiosk',
    helpingHands: 'Helping Hands',
    mentor: 'Mentor',
    integrations: 'Integrations',
    setup: 'Setup',
    monitoring: 'Monitoring',
    settings: 'Settings',
    championsOverview: 'Overview',
    activityLog: 'Activity Log',
    credentialIds: 'Credential IDs',
  }
}

export function getDrawerTopLevelLabels(t, organization) {
  return {
    organization: organization?.name || t('nav.organization'),
    people: t('nav.people'),
    champions: t('nav.champions'),
    messages: t('nav.messages'),
    donations: t('nav.donations'),
    tripPlanner: t('nav.tripPlanner'),
    groups: t('nav.groups'),
    events: t('nav.events'),
    kiosk: t('nav.kiosk'),
    helpingHands: t('nav.helpingHands'),
    mentor: t('nav.mentor'),
    integrations: t('nav.integrations'),
    setup: t('nav.setup'),
    monitoring: t('nav.monitoring'),
    settings: t('nav.settings'),
    championsOverview: t('nav.championsOverview', { defaultValue: 'Overview' }),
    activityLog: t('nav.activityLog', { defaultValue: 'Activity Log' }),
    credentialIds: t('nav.credentialIds', { defaultValue: 'Credential IDs' }),
  }
}
